export const ROW_PER_PAGE_OPTIONS = [5, 25, 75, 100];

export const MIN_PAGE_NUMBER = 1;
